import { useEdgeConfig } from '@/shared/modules/edge-config';

export const useGetFullInstallerUrl = (url: string): string => {
  const config = useEdgeConfig();
  const downloadInstallerServiceUrl = config?.globals?.downloadInstallerServiceUrl;

  const fullUrl = downloadInstallerServiceUrl ? downloadInstallerServiceUrl + url : url;
  return fullUrl;
};
